module.exports = __webpack_public_path__ + "img/P150T_weapon_88.2f3ca973.png";